import { useMemo } from 'react';
import { useGetIdentity } from 'react-admin';

export function useCompanyId() {
  const { data: identity, isLoading } = useGetIdentity();

  return useMemo(() => {
    if (isLoading) {
      return null;
    }

    return identity ? identity.companyId[0] : null;
  }, [identity, isLoading]);
}
